import React from 'react';
import ReactLoading from 'react-loading';

function Loader({ color = '#fff' }) {
  return <ReactLoading type="spin" color={color} height="60px" width="60px" />;
}

export default Loader;
